import { render, staticRenderFns } from "./UserSettingsPaymentsGateway.vue?vue&type=template&id=6058c715&"
import script from "./UserSettingsPaymentsGateway.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPaymentsGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports